export const getContraref = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contrarref_spontaneous/${id}`).then(
    (response) => {
      result = response.body.contraref[0];
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getContrarefSpontaneousPatientId = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contrarref_spontaneous/find_by_patient_id/${id}`).then(
    (response) => {
      result = response.body.data;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const getContrarefSpontaneousNodeDestinationId = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contraref_spontaneous/find_by_node_destination_id/${id}`).then(
    (response) => {
      result = response.body.contrarefs;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const GetContrarefSpontaneousFindByNodeId = async (resource, stablishment_id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contrarref_spontaneous/find_by_node_id/${stablishment_id}`).then(
    (response) => {
      result = response.body.data;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const ExportExcelContrarefSpontaneus = async (resource, stablishment_id) => {
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contrarref_spontaneous/export/` + stablishment_id, {
      responseType: "blob",
    })
    .then((response) => {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.ms-excel",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ContrareferenciasEspontaneas");
      document.body.appendChild(link);
      link.click();
    });
};

export const getContrarefSpontaneousByNodeId = async (resource, stablishment_id, page = 1) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}contraref_spontaneous/find_by_node_destination_paginate/${stablishment_id}?page=${page}`)
    .then(
      (response) => {
        result = response.body.contrarefs;
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};

export const getContrarefSpontaneousByNodeIdAndPatientId = async (resource, stablishment_id, patient_id, page = 1) => {
  let result;
  await resource
    .get(
      `api/${window.getApiUrlEntity(
        localStorage.getItem("perfil")
      )}contraref_spontaneous/find_by_node_destination_patient_id_paginate/${stablishment_id}/${patient_id}?page=${page}`
    )
    .then(
      (response) => {
        result = response.body.contrarefs;
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};
